(function(window, angular) {
  "use strict";

	angular.module('service')
	.factory('baseService', ['$http', '$window', '$httpParamSerializer', function($http, $window, $httpParamSerializer) {
		return {
			base_url: getFullUrl('/api/{object}'),
			base_prefix: '',
			/**
			 * init a new obj instance
			 * @param  {object} obj instance to update
			 * @return {object}      obj instance updated
			 */
			initObj: function(obj) {
				if( obj !== null ) {
					if( obj.created_at ) {
						obj.created_at = new Date(obj.created_at);
					}
					if( obj.updated_at ) {
						obj.updated_at = new Date(obj.updated_at);
					}
				}
				return obj;
			},

			/**
			 * return objs
			 * @param  object params 	filter
			 * @return object         objs promise
			 */
			search: function(params, page) {
				var this_instance = this;
				var url = this.base_url;

				if( page ) {
					if( !params ) {
						params = {};
					}
					params.page = page;
				}
				
				// var cleanParams = angular.copy(params);
				// angular.forEach(cleanParams, function (param, key) {
				// 	if (param instanceof Object) {
				// 		delete(cleanParams[key]);
				// 	}
				// });

				return $http({
					url: url,
					method: 'GET',
					params: params
				})
				.then(function(response) {
					var result = response.data;
					angular.forEach(result.data || result, function(obj, idx) {
						this_instance.initObj(obj);
					});
					return result;
				});
			},

			/**
			 * return a minimal search with only id and label
			 * @param  {Object} params
			 * @return {object}        http promise
			 */
			list: function(params) {
				if( params ) {
					params = angular.copy(params);
					params.list_only = 1;
				}
				else {
					params = {list_only:1};
				}
				return this.search(params);
			},

			/**
			 * returns and instance
			 * @param  {object} id
			 * @return {object}
			 */
			get: function(id) {
				var this_instance = this;

				return $http({
					url: this.base_url + '/' + id,
					method: 'GET'
				})
				.then(function(response) {
			  return this_instance.initObj(response.data);
			});
			},

			/**
			 * save a obj
			 * @param  object obj to save
			 * @return object     	obj promise
			 */
			save: function(obj) {
				var this_instance = this;
				var url    = this.base_url;
				var method = 'post';
				if( obj[this.base_prefix + 'id'] ) {
					method = 'put';
					url   += '/' +obj[this.base_prefix + 'id'];
				}

				return $http({
					method: method,
					url: url,
					data: obj
				}).then( function(response) {
					return this_instance.initObj(angular.extend(obj, response.data));
				});
			},
			/**
			 * return boolean
			 * @param  integer params 	obj[this.base_prefix + 'id']
			 * @return boolean          restore succeeded or not
			 */
			restore: function(obj) {
				var this_instance = this;
				return $http.get(this.base_url + '/' + obj[this.base_prefix + 'id'] + '/restore').then(function(response) {
				  return this_instance.initObj(response.data);
				});
			},

			/**
			 * delete a obj
			 * @param  integer id obj[this.base_prefix + 'id']
			 * @return object    http prmise
			 */
			delete: function(obj, forceDelete) {
				var this_instance = this;
				var params = {};
				if( forceDelete ) {
					params.forceDelete = 1;
				}

				return $http({
					url:this.base_url + '/' + obj[this.base_prefix + 'id'],
					method:'delete',
					params: params
				}).then(function(response) {
					return this_instance.initObj(response.data) || response;
				});
			},

			/**
			 * export searched data => it opens a new window with the exported data
			 * @param  {object} params (cf. search params)
			 * @return {none}
			 */
			export: function(params, page) {
				if( !page ) {
					page = 1;
				}

				var url = this.base_url + '/export?page=' + page;

				if( params ) {
					url += '&' + $httpParamSerializer(params);
				}
				$window.open(url);
			}
		}; // return
	}]);
})(window, window.angular);
